import { EMediaQuery } from 'src/styles/theme/utils/enums';
import {
	addFramesStyles,
	addHiddenRangesStyles,
	addMarginStyles,
	addOverflowStyles,
	addPaddingStyles,
	addTransition,
	getSpacing,
	mq
} from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';
import { IFlex } from './Flex.type';

// sonar-ignore-start
export const StyledFlex = styled.div<IFlex>`
	${(p) => css`
		position: relative;
		display: flex;

		${p.wrapItems ? 'flex-wrap: wrap;' : 'flex-wrap: nowrap;'}
		${addPaddingStyles(p)}
		${addMarginStyles(p)}
		${addFramesStyles(p)}
		${addHiddenRangesStyles(p)}
		${addOverflowStyles(p)}

		${p.isAnimated ? addTransition() : ''}

		${p.direction ? `flex-direction: ${p.direction};` : ''}
		${p.horizontal ? `justify-content: ${p.horizontal};` : ''}
		${p.vertical ? `align-items: ${p.vertical};` : ''}
		${p.gap ? `gap: ${getSpacing(p.gap)};` : ''}
		${p.fullWidth ? `width: 100%;` : ''}
		${p.fullHeight ? `height: 100%;` : ''}

		${typeof p.flexShrink !== 'undefined' ? `flex-shrink: ${p.flexShrink};` : ''}
		${typeof p.flexGrow !== 'undefined' ? `flex-grow: ${p.flexGrow};` : ''}
		${typeof p.flexBasis !== 'undefined' ? `flex-basis: ${p.flexBasis};` : ''}
		${p.flex ? `flex: ${p.flex};` : ''}

		${typeof p.xlFlexShrink !== 'undefined' ? mq(EMediaQuery.xl, `flex-shrink: ${p.xlFlexShrink};`) : ''}
		${typeof p.xlFlexGrow !== 'undefined' ? mq(EMediaQuery.xl, `flex-grow: ${p.xlFlexGrow};`) : ''}
		${typeof p.xlFlexBasis !== 'undefined' ? mq(EMediaQuery.xl, `flex-basis: ${p.xlFlexBasis};`) : ''}
		${p.xlFlex ? mq(EMediaQuery.xl, `flex: ${p.xlFlex};`) : ''}

		${typeof p.lgFlexShrink !== 'undefined' ? mq(EMediaQuery.lg, `flex-shrink: ${p.lgFlexShrink};`) : ''}
		${typeof p.lgFlexGrow !== 'undefined' ? mq(EMediaQuery.lg, `flex-grow: ${p.lgFlexGrow};`) : ''}
		${typeof p.lgFlexBasis !== 'undefined' ? mq(EMediaQuery.lg, `flex-basis: ${p.lgFlexBasis};`) : ''}
		${p.lgFlex ? mq(EMediaQuery.lg, `flex: ${p.lgFlex};`) : ''}

		${typeof p.mdFlexShrink !== 'undefined' ? mq(EMediaQuery.md, `flex-shrink: ${p.mdFlexShrink};`) : ''}
		${typeof p.mdFlexGrow !== 'undefined' ? mq(EMediaQuery.md, `flex-grow: ${p.mdFlexGrow};`) : ''}
		${typeof p.mdFlexBasis !== 'undefined' ? mq(EMediaQuery.md, `flex-basis: ${p.mdFlexBasis};`) : ''}
		${p.mdFlex ? mq(EMediaQuery.md, `flex: ${p.mdFlex};`) : ''}
		
		${typeof p.smFlexShrink !== 'undefined' ? mq(EMediaQuery.sm, `flex-shrink: ${p.smFlexShrink};`) : ''}
		${typeof p.smFlexGrow !== 'undefined' ? mq(EMediaQuery.sm, `flex-grow: ${p.smFlexGrow};`) : ''}
		${typeof p.smFlexBasis !== 'undefined' ? mq(EMediaQuery.sm, `flex-basis: ${p.smFlexBasis};`) : ''}
		${p.smFlex ? mq(EMediaQuery.sm, `flex: ${p.smFlex};`) : ''}

		${typeof p.xsFlexShrink !== 'undefined' ? mq(EMediaQuery.xs, `flex-shrink: ${p.xsFlexShrink};`) : ''}
		${typeof p.xsFlexGrow !== 'undefined' ? mq(EMediaQuery.xs, `flex-grow: ${p.xsFlexGrow};`) : ''}
		${typeof p.xsFlexBasis !== 'undefined' ? mq(EMediaQuery.xs, `flex-basis: ${p.xsFlexBasis};`) : ''}
		${p.xsFlex ? mq(EMediaQuery.xs, `flex: ${p.smFlex};`) : ''}


			${p.xlGap ? mq(EMediaQuery.xl, `gap: ${getSpacing(p.xlGap)};`) : ''}
			${p.lgGap ? mq(EMediaQuery.lg, `gap: ${getSpacing(p.lgGap)};`) : ''}
			${p.mdGap ? mq(EMediaQuery.md, `gap: ${getSpacing(p.mdGap)};`) : ''}
			${p.smGap ? mq(EMediaQuery.sm, `gap: ${getSpacing(p.smGap)};`) : ''}
			${p.xsGap ? mq(EMediaQuery.xs, `gap: ${getSpacing(p.xsGap)};`) : ''}

			${p.xsDirection || p.xsHorizontal || p.xsVertical
			? mq(
					EMediaQuery.xs,
					`
				${p.xsDirection ? `flex-direction: ${p.xsDirection};` : ''}
				${p.xsHorizontal ? `justify-content: ${p.xsHorizontal};` : ''}
				${p.xsVertical ? `align-items: ${p.xsVertical};` : ''}
			`
			  )
			: ''}
			${p.smDirection || p.smHorizontal || p.smVertical
			? mq(
					EMediaQuery.sm,
					`
				${p.smDirection ? `flex-direction: ${p.smDirection};` : ''}
				${p.smHorizontal ? `justify-content: ${p.smHorizontal};` : ''}
				${p.smVertical ? `align-items: ${p.smVertical};` : ''}
			`
			  )
			: ''}

			${p.mdDirection || p.mdHorizontal || p.mdVertical
			? mq(
					EMediaQuery.md,
					`
				${p.mdDirection ? `flex-direction: ${p.mdDirection};` : ''}
				${p.mdHorizontal ? `justify-content: ${p.mdHorizontal};` : ''}
				${p.mdVertical ? `align-items: ${p.mdVertical};` : ''}
			`
			  )
			: ''}

			${p.lgDirection || p.lgHorizontal || p.lgVertical
			? mq(
					EMediaQuery.lg,
					`
				${p.lgDirection ? `flex-direction: ${p.lgDirection};` : ''}
				${p.lgHorizontal ? `justify-content: ${p.lgHorizontal};` : ''}
				${p.lgVertical ? `align-items: ${p.lgVertical};` : ''}
			`
			  )
			: ''}

			${p.xlDirection || p.xlHorizontal || p.xlVertical
			? mq(
					EMediaQuery.xl,
					`
				${p.xlDirection ? `flex-direction: ${p.xlDirection};` : ''}
				${p.xlHorizontal ? `justify-content: ${p.xlHorizontal};` : ''}
				${p.xlVertical ? `align-items: ${p.xlVertical};` : ''}
			`
			  )
			: ''}
	`}
`;
// sonar-ignore-end
